import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useTranslation } from 'react-i18next';
import { brand } from "../config/brand";

function Header() {
  const { t } = useTranslation();
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  function toggleMobileMenu() {
    setShowMobileMenu(!showMobileMenu);
  }

  function closeMobileMenu() {
    setShowMobileMenu(false);
  }

  const navLink =
    "text-sm font-semibold uppercase tracking-wide text-ink-200 transition-colors hover:text-signal-400";

  return (
    <header className="absolute inset-x-0 top-0 z-50">
      <nav
        className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
        aria-label="Global"
      >
        <div className="flex lg:flex-1">
          <Link to="/" onClick={closeMobileMenu} className="-m-1.5 p-1.5">
            <Logo size="md" animated />
          </Link>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-ink-200"
            onClick={toggleMobileMenu}
          >
            <span className="sr-only">{showMobileMenu ? "Close" : "Open"} main menu</span>
            <svg className={`h-6 w-6 ${showMobileMenu ? "hidden" : "block"}`} fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <svg className={`h-6 w-6 ${showMobileMenu ? "block" : "hidden"}`} fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="hidden lg:flex lg:gap-x-10">
          <Link to="/" onClick={closeMobileMenu} data-testid="main-menu-home-link" className={navLink}>
            {t('header-main')}
          </Link>
          <Link to="/tracking" onClick={closeMobileMenu} data-testid="main-menu-tracking-link" className={navLink}>
            {t('header-tracking')}
          </Link>
          <Link to="/contacts" onClick={closeMobileMenu} data-testid="main-menu-contacts-link" className={navLink}>
            {t('header-contacts')}
          </Link>
        </div>
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          <Link
            to={brand.cabinetUrl}
            onClick={closeMobileMenu}
            data-testid="main-menu-cabinet-link"
            className="group inline-flex items-center gap-2 rounded-full border border-signal-500/40 bg-signal-500/10 px-5 py-2 text-sm font-semibold uppercase tracking-wide text-signal-400 transition-all hover:bg-signal-500 hover:text-white"
            target="_blank"
          >
            {t('header-cabinet')}
            <span aria-hidden="true" className="transition-transform group-hover:translate-x-0.5">&rarr;</span>
          </Link>
        </div>
      </nav>

      {/* Mobile menu */}
      <div className={`lg:hidden ${showMobileMenu ? "block" : "hidden"}`} role="dialog" aria-modal="true">
        <div className="fixed inset-0 z-50 bg-night-900/70 backdrop-blur-sm" onClick={toggleMobileMenu}></div>
        <div className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-night-800 px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-white/10">
          <div className="flex items-center justify-between">
            <Link to="/" onClick={closeMobileMenu} className="-m-1.5 p-1.5">
              <span className="sr-only">Forpost</span>
              <Logo size="sm" />
            </Link>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-ink-200"
              onClick={toggleMobileMenu}
            >
              <span className="sr-only">{t('header-close-menu')}</span>
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className="mt-8 flow-root">
            <div className="-my-6 divide-y divide-white/10">
              <div className="space-y-1 py-6">
                <Link to="/" onClick={closeMobileMenu} id="main-mobile-menu-home-link" className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold uppercase tracking-wide text-ink-100 hover:bg-white/5 hover:text-signal-400">
                  {t('header-main')}
                </Link>
                <Link to="/tracking" onClick={closeMobileMenu} id="main-mobile-menu-tracking-link" className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold uppercase tracking-wide text-ink-100 hover:bg-white/5 hover:text-signal-400">
                  {t('header-tracking')}
                </Link>
                <Link to="/contacts" onClick={closeMobileMenu} id="main-mobile-menu-contacts-link" className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold uppercase tracking-wide text-ink-100 hover:bg-white/5 hover:text-signal-400">
                  {t('header-contacts')}
                </Link>
              </div>
              <div className="py-6">
                <Link to={brand.cabinetUrl} target="_blank" onClick={closeMobileMenu} id="main-mobile-menu-cabinet-link" className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold uppercase tracking-wide text-signal-400 hover:bg-white/5">
                  {t('header-cabinet')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
